import React, { useState, useEffect, useContext } from 'react';
import { AudioContext } from '../context/AudioContext';
import { BASE_URL } from "../config/config";
import { Link } from 'react-router-dom';

const AllChannels = () => {
    const [history, setHistory] = useState([]);
    const { setCurrentChannel } = useContext(AudioContext);
    const [allChannels, setAllChannels] = useState([]);

    useEffect(() => {
        const storedHistory = sessionStorage.getItem('radioHistory');
        if (storedHistory) {
            setHistory(JSON.parse(storedHistory));
        }

        const fetchAllChannels = async () => {
            try {
                const response = await fetch(`${BASE_URL}/all-channels`);
                const data = await response.json();
                setAllChannels(data);
            } catch (error) {
                console.error('Error fetching radio channels:', error);
            }
        };

        fetchAllChannels();

    }, []);

    const playChannel = (channel) => {
        setCurrentChannel(channel);

        // Update history
        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length) updatedHistory.pop(); // Limit history to 5 items

        setHistory(updatedHistory);
        sessionStorage.setItem('radioHistory', JSON.stringify(updatedHistory));
    };

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title">
                            <h2>All Channels</h2>
                        </div>
                    </div>

                    {allChannels.length === 0 ? (
                        <div className="col-12">
                            <p>No channels found.</p>
                        </div>
                    ) : (
                        allChannels.map((channel) => (
                            <div className="col-6 col-sm-4 col-lg-1">
                                <div className="album">
                                    <div className="album__cover" key={channel.id} onClick={() => playChannel(channel)}>
                                        <img src={channel.favicon} alt={`${channel.name} logo`} />
                                        <Link to="#" onClick={() => playChannel(channel)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                            </svg>
                                        </Link>
                                    </div>
                                    <div className="album__title">
                                        <h3 className='text-capitalize'><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h3>
                                        <span className='text-capitalize'><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="partners owl-carousel">
                        
                    </div>
                </div>
            </div>
        </main>
    );
};

export default AllChannels;
